/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetReleaseRequest} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'
import {GetReleaseResponse} from '@cash-web/protos/squareup/cash/mosaic/resources/api/v2/release.pb'


export const getRelease = (request: GetReleaseRequest, options?: CashRequestOptions) => post<GetReleaseRequest, GetReleaseResponse>("/2.0/cash/get-release", request, {...options, rejectOnError: true })